import { MouseEvent } from 'react';
import {
  ModelForm,
  useIsMsalAuth,
  useProgrammaticLink,
} from '@equifinance/shared';
import styled from 'styled-components';
import ProductSidebarFooter from '../components/Products/ProductSidebar/ProductSidebarFooter';
import CompanyTabPage, { CompanyPageType } from '../components/Company/components/CompanyTabPage';
import BrokerDetailsSidebar from '../components/BrokerDetails/components/BrokerDetailsSidebar';
import FirmDetailsSection from '../components/BrokerDetails/sections/FirmDetails';
import SystemSettingsSection from '../components/BrokerDetails/sections/SystemSettings';
import { useCompanyContext } from '../contexts/company';
import { CommercialsSection } from '../components/BrokerDetails/sections/Commercials';
import { AnnualReviewSection } from '../components/BrokerDetails/sections/AnnualReview';

export const ErrorContainer = styled.div` ${({ theme }) => `
  padding-bottom: ${theme.padding[4]};
`}`;

export default function BrokerDetails() {
  const isInternalUser = useIsMsalAuth();
  const clickHomeLink = useProgrammaticLink('/');

  const onClickLogo = (event?: MouseEvent<HTMLElement>) => {
    clickHomeLink(event);
  };

  const { company, updateCompany } = useCompanyContext();

  const update = (values: Record<string, any>) => {
    Object.entries(values).forEach(([field, value]) => {
      updateCompany(field, value);
    });
  };

  return (
    <CompanyTabPage
      sidebar={<BrokerDetailsSidebar />}
      sidebarFooter={<ProductSidebarFooter />}
      onClickLogo={onClickLogo}
      page={CompanyPageType.BROKER_DETAILS}
    >
      <ModelForm model={company} update={update}>
        <FirmDetailsSection />
        <SystemSettingsSection />
        {isInternalUser && (
          <>
            <CommercialsSection />
            <AnnualReviewSection />
          </>
        )}
      </ModelForm>
    </CompanyTabPage>
  );
}
